
import { Vue, Options } from "vue-class-component";
import { SttHangingController } from "@/app/ui/controllers/SttHangingController";
import {
  HistoryHangingBookingFilterRequest,
  HistoryHangingBookingEntities,
  HistoryHangingBooking
} from "@/domain/entities/HangingBooking";
import PaginationV3 from "@/app/ui/components/pagination-v3/index.vue";
import formatDate from "@/app/infrastructures/misc/common-library/FormatDate";
import FilterHistory from "../../../console/hanging/components/filter-history.vue";
import { debounce } from "lodash";

@Options({
  components: {
    PaginationV3,
    FilterHistory
  }
})
class TabRiwayatHangingBooking extends Vue {
  historyDataEntities = new HistoryHangingBookingEntities();
  filter = new HistoryHangingBookingFilterRequest();
  loading = false;
  errorCause = "";

  mounted() {
    this.getHistoryHangingBooking(new HistoryHangingBookingFilterRequest());
  }

  get historyPagination() {
    return this.historyDataEntities.pagination;
  }

  get historyData() {
    return this.historyDataEntities.data;
  }

  get offset() {
    return (
      this.historyDataEntities.pagination.limit *
      (this.historyDataEntities.pagination.page - 1)
    );
  }

  filterHistoryHangingBooking = debounce(
    (filter: HistoryHangingBookingFilterRequest) => {
      if (this.loading) return;
      this.filter = filter;
      this.getHistoryHangingBooking(this.filter);
    },
    250
  );

  async getHistoryHangingBooking(filter: HistoryHangingBookingFilterRequest) {
    this.errorCause = "";
    try {
      this.loading = true;
      const res = await SttHangingController.getHistoryHangingBooking(filter);
      this.historyDataEntities = res;
    } catch (err) {
      const error = err as { response?: unknown };
      this.errorCause = error.response ? "server" : "internet";
    } finally {
      this.loading = false;
    }
  }

  toPageV3(value: number) {
    if (value === this.historyPagination.page) {
      return;
    }
    this.historyDataEntities.pagination.page = value;
    this.filter.page = value;
    this.getHistoryHangingBooking(this.filter);
  }

  mapHangingDays(item: HistoryHangingBooking) {
    const colorMap: Record<number, string> = {
      1: "bg-aqua-lp-200 text-aqua-lp-500",
      2: "bg-aqua-lp-200 text-aqua-lp-500",
      3: "bg-aqua-lp-200 text-aqua-lp-500",
      4: "bg-aqua-lp-200 text-aqua-lp-500",
      5: "bg-yellow-lp-200 text-yellow-lp-100",
      6: "bg-orange-lp-100 text-orange-lp-200"
    };

    let color = "bg-white text-gray-lp-300";

    if (item.hangingDays != null) {
      if (colorMap[item.hangingDays]) {
        color = colorMap[item.hangingDays];
      } else if (item.hangingDays >= 7) {
        color = "bg-red-lp-2000 text-white";
      }
    }

    const label =
      item.hangingDays != null
        ? item.hangingDays < 7
          ? `${item.hangingDays} ${this.$t(
              "dashboard.hangingBkd.historyPage.historyHanging.days"
            )}`
          : this.$t("dashboard.hangingBkd.historyPage.historyHanging.day7Plus")
        : "-";

    return { label, color };
  }

  mapTicketStatus(stt: HistoryHangingBooking) {
    switch (stt.existenceStatus) {
      case "belum_ditemukan":
        return {
          label: this.$t(
            "dashboard.hangingBkd.historyPage.historyHanging.notFound"
          ),
          color: "bg-pink-lp-200 text-red-lp-100"
        };
      case "ditemukan_konsol":
        return {
          label: this.$t(
            "dashboard.hangingBkd.historyPage.historyHanging.foundConsole"
          ),
          color: "bg-blue-lp-600 text-blue-lp-700"
        };
      case "ditemukan_pos":
        return {
          label: this.$t(
            "dashboard.hangingBkd.historyPage.historyHanging.foundPos"
          ),
          color: "bg-purple-lp-100 text-purple-lp-800"
        };
      default:
        return {
          label: "-",
          color: ""
        };
    }
  }

  // Format Date
  formatDateToString(date: string) {
    return formatDate(date);
  }
}

export default TabRiwayatHangingBooking;
